import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as o, openBlock as n, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconThermometerSnowflake",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 1.5a.5.5 0 0 0-.5.5v5.27a.5.5 0 0 1-.25.433 1.5 1.5 0 1 0 1.5 0 .5.5 0 0 1-.25-.433V2a.5.5 0 0 0-.5-.5ZM7.94.94A1.5 1.5 0 0 1 10.5 2v5.002a2.5 2.5 0 1 1-3 0V2c0-.398.158-.78.44-1.06Z"
}, null, -1), m = /* @__PURE__ */ e("path", { d: "M.5 6a.5.5 0 0 1 .5-.5h.793l-.647-.646a.5.5 0 1 1 .708-.708L3.207 5.5H4v-.793L2.646 3.354a.5.5 0 1 1 .708-.708L4 3.293V2a.5.5 0 0 1 1 0v1.293l.646-.647a.5.5 0 1 1 .708.708L5 4.707V5.5h1a.5.5 0 0 1 0 1H5v.793l.604.603A.5.5 0 0 1 5 8.683V10a.5.5 0 0 1-1 0V8.707l-.646.647a.5.5 0 1 1-.708-.708L4 7.293V6.5h-.793L1.854 7.854a.5.5 0 1 1-.708-.708l.647-.646H1A.5.5 0 0 1 .5 6Z" }, null, -1), f = [
  u,
  m
], p = ["id"], v = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  v
];
function I(a, L, l, S, w, t) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: d([t.iconSizeClass, "d-icon d-icon--thermometer-snowflake"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Thermometer Snowflake",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`,
      fill: "currentColor"
    }, f, 8, _),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, g, 8, p)
    ])
  ], 10, h);
}
const z = /* @__PURE__ */ s(c, [["render", I]]);
export {
  z as default
};
//# sourceMappingURL=thermometer-snowflake.js.map
